// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';
import { ButtonSmallLayout } from '../common/buttons/ButtonSmallLayout';

const raw = {
  width: 620,
  height: 910,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: undefined,
      stateByName: {}
    },
    {
      id: '8b7ecf34-c1a5-4c5f-9c98-497748d2c28e',
      type: 'Container',
      runtimeType: null,
      name: 'popup',
      className: '',
      x: 310,
      y: 455,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '22590228-3db2-480d-a578-3c9c827f964d',
      type: 'Container',
      runtimeType: null,
      name: 'background',
      className: '',
      x: 0,
      y: 5,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8b7ecf34-c1a5-4c5f-9c98-497748d2c28e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '703d260b-ddca-462c-b436-13a0e51d26bd',
      type: 'Container',
      runtimeType: null,
      name: 'levelContainer',
      className: '',
      x: 0,
      y: -169,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8b7ecf34-c1a5-4c5f-9c98-497748d2c28e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '17f21d9c-72d0-44f1-9308-2899a18d49a0',
      type: 'Container',
      runtimeType: null,
      name: 'header',
      className: '',
      x: 0,
      y: -351,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8b7ecf34-c1a5-4c5f-9c98-497748d2c28e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '05192204-0cd2-4a17-b230-47813e77cc04',
      type: 'Container',
      runtimeType: null,
      name: 'rewards',
      className: '',
      x: 0,
      y: 69,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8b7ecf34-c1a5-4c5f-9c98-497748d2c28e',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'f0f79c0c-2572-4325-8dd2-954c0b33a2fd',
      type: 'Container',
      runtimeType: null,
      name: 'buttons',
      className: '',
      x: 0,
      y: 310,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8b7ecf34-c1a5-4c5f-9c98-497748d2c28e',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'b091b650-5db9-4b31-b5d1-38fefbb0820d',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.180851,
        y: 1.031288
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Pop_Up_Background',
      parent: '22590228-3db2-480d-a578-3c9c827f964d',
      data: undefined,
      stateByName: {}
    },
    {
      id: '8b8dad89-81b2-42b7-8f14-af8daabec7ff',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -242,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Yellow_Band',
      parent: '22590228-3db2-480d-a578-3c9c827f964d',
      data: undefined,
      stateByName: {}
    },
    {
      id: '2092af5f-64f0-4985-8b62-e0d38c1e30a1',
      type: 'Text',
      runtimeType: null,
      name: 'levelText',
      className: '',
      x: 0,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Level 1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fefffd',
        stroke: '#712316',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '703d260b-ddca-462c-b436-13a0e51d26bd',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'd3448181-c167-4936-acdd-20be69d0a4f1',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 21,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Complete!',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fefffd',
        stroke: '#712316',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '703d260b-ddca-462c-b436-13a0e51d26bd',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'e8fe0651-c07e-4c40-a2e8-3d97faa68424',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Blue_Header',
      parent: '17f21d9c-72d0-44f1-9308-2899a18d49a0',
      data: undefined,
      stateByName: {}
    },
    {
      id: '543c426c-0cae-4076-9da6-3c8372c064b6',
      type: 'Text',
      runtimeType: null,
      name: 'headerText',
      className: '',
      x: 0,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Nice Job!',
      localize: true,
      maxWidth: 410,
      maxHeight: 178,
      maxFontSize: 0,
      style: {
        fontSize: 61,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0047b1',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '17f21d9c-72d0-44f1-9308-2899a18d49a0',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'ced4d853-bf69-4372-b0e2-09c9ce811e93',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Win_Rewards_Background',
      parent: '05192204-0cd2-4a17-b230-47813e77cc04',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6f9b1608-614a-43b4-874d-30d041bf7ed6',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Rewards',
      localize: true,
      maxWidth: 344,
      maxHeight: 72,
      maxFontSize: 0,
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#fff4da',
        stroke: '#712316',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '05192204-0cd2-4a17-b230-47813e77cc04',
      data: undefined,
      stateByName: {}
    },
    {
      id: '375e1974-f2e3-44a4-92ad-2e62bc2ae064',
      type: 'Container',
      runtimeType: null,
      name: 'rewardsSlot',
      className: '',
      x: 0,
      y: -9,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '05192204-0cd2-4a17-b230-47813e77cc04',
      data: undefined,
      stateByName: {}
    },
    {
      id: '5e0eeadf-1864-47af-bd3f-aa8fb29cdc00',
      type: 'Layout',
      runtimeType: null,
      name: 'nextButton',
      className: '',
      path: 'common/buttons/ButtonSmallLayout.ts',
      percentX: 0,
      percentY: 0,
      x: -150,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: 'f0f79c0c-2572-4325-8dd2-954c0b33a2fd',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      },
      stateByName: {}
    },
    {
      id: 'd64f831a-365c-42b8-a8e3-1d3c58361575',
      type: 'Container',
      runtimeType: null,
      name: 'doubleCoinsButton',
      className: '',
      x: 117,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'f0f79c0c-2572-4325-8dd2-954c0b33a2fd',
      data: undefined,
      stateByName: {
        noDoubleCoins: {
          visible: false
        }
      }
    },
    {
      id: '6e3bfae2-7a78-4abf-b6fe-61c93b9d445b',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Next',
      localize: true,
      maxWidth: 186,
      maxHeight: 121,
      maxFontSize: 0,
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0138f4',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '5e0eeadf-1864-47af-bd3f-aa8fb29cdc00',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fa578071-8c33-4a6c-a01c-0116757919eb',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 138,
        y: 55
      },
      width: 276,
      height: 110,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Yellow',
      parent: 'd64f831a-365c-42b8-a8e3-1d3c58361575',
      data: undefined,
      stateByName: {}
    },
    {
      id: '2884c898-8973-4b5a-b3ee-d760debb5c0f',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -131,
      y: -52,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Button_Corner_Shadow',
      parent: 'd64f831a-365c-42b8-a8e3-1d3c58361575',
      stateByName: {},
      data: undefined
    },
    {
      id: '9dc91911-044a-4e89-8ae0-e93df80bb27a',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -113,
      y: -37,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Wtach_Ad_Orange_Icon',
      parent: 'd64f831a-365c-42b8-a8e3-1d3c58361575',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'c86a9905-7eb5-4243-8bd3-4b1e633d2b56',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 2,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Double Coins',
      localize: true,
      maxWidth: 186,
      maxHeight: 101,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#c63300',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 40,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd64f831a-365c-42b8-a8e3-1d3c58361575',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [
    'noDoubleCoins'
  ],
  animations: []
} as const;

export class WinPopupLayout {
  static raw = raw;
  root: Container;
  popup: Container;
  background: Container;
  levelContainer: Container;
  header: Container;
  rewards: Container;
  buttons: Container;
  levelText: Text;
  headerText: Text;
  rewardsSlot: Container;
  nextButton: ButtonSmallLayout & { data: typeof raw['list'][16]['data'] };
  doubleCoinsButton: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'noDoubleCoins';
    ModelByName: {
      root: typeof raw['list'][0];
      popup: typeof raw['list'][1];
      background: typeof raw['list'][2];
      levelContainer: typeof raw['list'][3];
      header: typeof raw['list'][4];
      rewards: typeof raw['list'][5];
      buttons: typeof raw['list'][6];
      levelText: typeof raw['list'][9];
      headerText: typeof raw['list'][12];
      rewardsSlot: typeof raw['list'][15];
      nextButton: typeof raw['list'][16];
      doubleCoinsButton: typeof raw['list'][17];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
